import React from 'react';

interface StatusBannerProps {
  status: 'healthy' | 'unavailable' | 'loading';
  message: string;
  detail?: string;
}

export const StatusBanner: React.FC<StatusBannerProps> = ({ status, message, detail }) => {
  if (status === 'unavailable') {
    return (
      <div className="bg-red-950/80 border-2 border-red-600 rounded-lg p-4 my-4 flex items-center gap-3 shadow-lg shadow-red-950/40">
        <div className="w-3 h-3 rounded-full bg-red-500 animate-ping" />
        <div>
          <div className="text-red-400 font-bold text-lg tracking-wide uppercase">
            {message}
          </div>
          {detail && <div className="text-red-300/80 text-sm mt-0.5">{detail}</div>}
        </div>
      </div>
    );
  }

  if (status === 'healthy') {
    return (
      <div className="bg-emerald-950/50 border border-emerald-600/40 rounded-lg p-4 my-4 flex items-center gap-3">
        <div className="w-3 h-3 rounded-full bg-emerald-400" />
        <div>
          <div className="text-emerald-300 font-semibold">{message}</div>
          {detail && <div className="text-emerald-400/70 text-sm">{detail}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-800/60 border border-gray-700 rounded-lg p-4 my-4 flex items-center gap-3 text-gray-300">
      <div className="w-3 h-3 rounded-full bg-blue-400 animate-pulse" />
      <div>{message}</div>
    </div>
  );
};
